import { Injectable, ErrorHandler } from '@angular/core';
import { LogService } from '../services/log.service';
import { SentryService } from '../services/sentry.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(
    private logService: LogService,
    private sentryService: SentryService) {
    super();
  }

  handleError(error) {
    this.logService.error(error);
    this.sentryService.error(error);
  }
}



// WEBPACK FOOTER //
// ./client/app/global/error-handler.ts